import { Controller } from "@hotwired/stimulus";

export default class ContactFormCustomFieldsController extends Controller {
  static targets = [
    "fieldsContainer",
    "tableBody",
    "fieldRow",
    "destroyInput",
    "rowTemplate",
    "emptyState",
    "table",
  ];
  static values = { nextIndex: Number };

  connect() {
    this._index = this.nextIndexValue || 0;
  }

  get nextIndex() {
    return this._index++;
  }

  addField() {
    if (this.hasEmptyStateTarget) {
      this.emptyStateTarget.classList.add("hidden");
    }
    if (this.hasTableTarget) {
      this.tableTarget.classList.remove("hidden");
    }

    const template = this.rowTemplateTarget.innerHTML;
    const newRow = template.replace(/NEW_INDEX/g, this.nextIndex);
    const tbody = this.tableBodyTargets[this.tableBodyTargets.length - 1];
    tbody.insertAdjacentHTML("beforeend", newRow);
  }

  removeField(event) {
    const row = event.target.closest("tr");
    const destroyInput = row.querySelector(
      '[data-contact-form-custom-fields-target="destroyInput"]'
    );

    if (destroyInput) {
      const idInput = row.querySelector('input[name*="[id]"]');
      if (idInput) {
        // Existing record: mark for destruction instead of removing from DOM
        destroyInput.value = "true";
        row.classList.add("hidden");
      } else {
        row.remove();
      }
    }

    if (this.hasTableTarget) {
      const visibleRows = this.tableBodyTarget.querySelectorAll("tr:not(.hidden)");
      if (visibleRows.length === 0) {
        this.tableTarget.classList.add("hidden");
      }
    }
  }
}
